/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SyncInstrumentLinkRegionRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/SyncInstrumentLinkRegion.pb'
import {SyncInstrumentLinkRegionResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/SyncInstrumentLinkRegion.pb'


export const syncInstrumentLinkRegion = (request: SyncInstrumentLinkRegionRequest, options?: CashRequestOptions) => post<SyncInstrumentLinkRegionRequest, SyncInstrumentLinkRegionResponse>("/2.0/cash/sync-instrument-link-region", request, {...options, rejectOnError: true })